import DirectoryProfile from './DirectoryProfile';

export default DirectoryProfile;
